import { createContext, useContext } from 'react'

import type {
  OriginOption,
  Session,
  SessionLocation,
  SessionRole,
  SessionUser,
  StageOption,
} from '@/features/auth/types'
import type { AuthStatus } from '@/stores/authStore'
import type { Workspace } from '@/types/workspace'

export interface AuthContextValue {
  status: AuthStatus
  isAuthenticated: boolean
  session: Session | null
  user: SessionUser | null
  role: SessionRole | null
  location: SessionLocation | null
  isPlatform: boolean
  today: string | null
  origins: OriginOption[]
  stages: StageOption[]
  locations: SessionLocation[]
  workspace: Workspace | null
}

export const AuthContext = createContext<AuthContextValue | null>(null)

export function useAuth(): AuthContextValue {
  const value = useContext(AuthContext)
  if (!value) throw new Error('useAuth must be used inside <AuthProvider>')
  return value
}
